import { useEffect, useState } from 'react';

/**
 * Keep an element mounted through its exit animation.
 *
 * @param {boolean} open             the wanted state
 * @param {number|() => number} exitMs how long the exit animation runs — a
 *   function is read only when the exit starts (e.g. a CSS token: reading
 *   computed style on every render forces a style recalc each time)
 * @returns {{ mounted: boolean, closing: boolean }}
 *   mounted — render it; closing — it is on its way out (play the exit, ignore input)
 */
const usePresence = (open, exitMs) => {
  const [lingering, setLingering] = useState(open);

  useEffect(() => {
    if (open) {
      setLingering(true);
      return undefined;
    }
    const ms = typeof exitMs === 'function' ? exitMs() : exitMs;
    const timer = setTimeout(() => setLingering(false), ms);
    return () => clearTimeout(timer);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return { mounted: open || lingering, closing: !open && lingering };
};

export default usePresence;
